import { AppCrimsCasosObertsProps } from './AppCrimsCasosOberts.types';
import __isEmpty from 'lodash/isEmpty';
import styles from './appcrimscasosoberts.module.scss';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac';
const Enllac: any = EnllacComponent;
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Titol from 'components/corporatiu/Titol/Titol';
// @ts-ignore
import { useViewport } from 'hooks/corporatiu/useViewport';
import clsx from 'clsx';

const AppCrimsCasosOberts = (props: Readonly<AppCrimsCasosObertsProps>) => {
    const { seccio, item } = props;
    const { isMobile } = useViewport();

    const stylesHero = clsx({
        [styles.hero]: true,
        [styles.isMobile]: isMobile
    });

    if (!item) return null;

    switch (seccio) {
        case 'cap':
            return <div className={stylesHero}></div>;
        case 'text':
            return (
                <article className={styles.appCrimsCasosOberts}>
                    <Titol titol={item.titol} tag='h1' estil='titolPagina' />

                    <p>{item.disponible}</p>

                    {!__isEmpty(item.aplicacions) &&
                        item.aplicacions?.map((app, index) => (
                            <div key={index} className={styles.markets}>
                                <Enllac href={app.links[0].url} title={app.links[0].nom}>
                                    <Imatge
                                        src={'https://statics.3cat.cat/recursos/ccma/apple-app-store.svg'}
                                        loading='lazy'
                                        width={88}
                                        height={26}
                                        alt={`${app.nom} ${app.links[0].nom}`}
                                        aria-hidden='true'
                                    />
                                </Enllac>
                                <Enllac href={app.links[1].url} title={app.links[1].nom}>
                                    <Imatge
                                        src={'https://statics.3cat.cat/recursos/ccma/google-play.svg'}
                                        loading='lazy'
                                        width={100}
                                        height={26}
                                        alt={`${app.nom} ${app.links[1].nom}`}
                                        aria-hidden='true'
                                    />
                                </Enllac>
                            </div>
                        ))}

                    <Text text={item.descarrega} tag='div' className='gapAfter' />
                    <Text text={item.condicions} tag='div' className='gapAfter' />
                    <Text text={item.ajuda} tag='div' className='gapAfter' />

                    <div className={styles.mosaic}>
                        <div className={styles.mosaicItem}>
                            <Imatge
                                src={'https://img.3cat.cat/multimedia/png/2/2/1714381035022.png'}
                                loading='lazy'
                                width={338}
                                height={55}
                                alt='Líders en crònica negra'
                                aria-hidden='true'
                            />
                        </div>
                        <div className={styles.mosaicTira}>
                            <Enllac href={'https://www.3cat.cat/3cat/tor-tretze-cases-i-tres-morts/'}>
                                <Imatge
                                    src={'https://img.3cat.cat/multimedia/jpg/4/3/1705569196934_384.jpg'}
                                    loading='lazy'
                                    width={384}
                                    height={562}
                                    alt='Tor, la muntanya maleïda'
                                    aria-hidden='true'
                                />
                            </Enllac>
                            <Enllac href={'https://www.3cat.cat/3cat/oj-simpson-sang-mentides-i-assassinat/'}>
                                <Imatge
                                    src={'https://img.3cat.cat/multimedia/jpg/4/5/1713944755254_384.jpg'}
                                    loading='lazy'
                                    width={384}
                                    height={562}
                                    alt='O.J. Simpson: sang, mentides i assassinat'
                                    aria-hidden='true'
                                />
                            </Enllac>
                            <Enllac href='https://www.3cat.cat/3cat/manson-les-cintes-perdudes/video/6278922/'>
                                <Imatge
                                    src='https://img.3cat.cat/multimedia/jpg/0/3/1714136233230_384.jpg'
                                    alt='Manson: les cintes perdudes'
                                    width='384'
                                    loading='lazy'
                                    height='562'
                                />
                            </Enllac>
                            <Enllac href='https://www.3cat.cat/3cat/crims/'>
                                <Imatge
                                    src='https://img.3cat.cat/multimedia/jpg/2/5/1678804289452_384.jpg'
                                    alt='Crims'
                                    width='384'
                                    loading='lazy'
                                    height='562'
                                />
                            </Enllac>
                        </div>
                    </div>
                </article>
            );
    }
};

export default AppCrimsCasosOberts;
